module.exports = __webpack_public_path__ + "static/media/sound2.04054870.mp3";